import angular from 'angular';
import 'angular-touch';
import { OnboardingDocumentW4FormComponent } from './onboarding-document-w4-form.component';
import { OnboardingDocumentRoutingModule } from './onboarding-document-routing.module';
import { OnboardingDocumentService } from '../../core/services/data-services/onboarding-document.service';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { NyW4Component } from './ny/ny-w4.component';
import { AlW4Component } from './al/al-w4.component';
import { ArW4Component } from './ar/ar-w4.component';
import { AZW4Component } from './az/az-w4.component';
import { I9Component } from './i9/i9.component';
import { ResetComponent } from './reset.component';
import { DirectDepositComponent } from './direct-deposit/direct-deposit.component';
import { OnboardingDocumentViewService } from './onboarding-document-view-service';
import { ConfirmationFormComponent } from './confirmation-form/confirmation-form.component';
import { EmployeeService , LocaleService } from '../../core/services';

import { FederalW4SignatureFormComponent } from './federal-w4-signature/federal-w4-signature-form.component';
import { FederalW4Component } from './federal-w4/federal-w4.component';
import { EmpPortalComponent } from './portal/employee/emp-portal.component';
import { SharedModule } from '../shared/shared.module';

import 'angular-pdfjs-viewer';
// Make sure trix is loaded, since the page loads the apex-trix-editor
import "trix"
import "trix/dist/trix.css"
import { AddBankAccountComponent } from './bank-accounts/add-bank-account.component';
//import { I9SignatureComponent } from './signature/i9-signature.signature';
import { CoW4Component } from './co/co-w4.component';
import { KyW4Component } from './ky/ky-w4.component';
import { GaW4Component } from './ga/ga-w4.component';
import { MdW4Component } from './md/md-w4.component';
import { OwnerModalComponent } from './owner-modal/owner-modal.component';
import { ConfirmationEmployerComponent } from './confirmation-form/confirmation-employer.component';
import { StateBoilerPlateComponent } from './boilerplate/boiler-plate.component';
import { SignaturePadComponent } from './signature/signature-pad.component';
import { SignaturePadDirective } from './signature/signaturepad.directive';
import { OnboardingDateDirective } from './onboarding-date.directive';
import { PreviewSignatureModalComponent } from './preview-signature-modal/preview-signature-modal.component';
import { InfoModalComponent } from './info-modal/info-modal.component';
import { ReviewModalComponent } from './review-modal/review-modal.component';
import { DashboardOnboardingContainerComponent } from './onboarding-dashboard/onboarding-dashboard-container.component';
import { DashboardOnboardingComponent } from './onboarding-dashboard/onboarding-dashboard.component';
import { dashboardOnboardingItemTemplate, dashboardOnboardingListItemTemplate } from './onboarding-dashboard/dashboard-onboarding-templates.block';
import { CaW4Component } from './ca/ca-w4.component';
import { W9Component } from './w9/w9.component';
import { PreviewSignatureOwnerModalComponent } from './preview-signature-modal/preview-signature-owner-modal.component';
import { OwnerPreviewSignatureModalComponent } from './preview-signature-modal/owner-preview-signature-modal.component';
import { OnboardingCommentsComponent } from './comments/onboarding-comments';
import { CtW4Component } from './ct/ct-w4.component';
import { TerminationModalComponent } from './termination-modal/termination-modal.component';
import { EmpPortalItemsComponent } from './portal/employee/emp-portal-items.component';
import { DashboardItemsOnboardingComponent } from './onboarding-dashboard/onboarding-dashboard-items.component';
import { OnboardingActionPolicyService } from "./onboarding-action-policy.service";
import { PressRevealDirective } from './signature/pressreveal.directive';
import { VoidCheckModalComponent } from './direct-deposit/void-check-modal.component';
import { VaW4Component } from './va/va-w4.component';
import { IlW4Component } from './il/il-w4.component';
import { FormChoiceModalComponent } from './form-choice-modal/form-choice-modal.component';
import { OnboardingUpdateModalComponent } from './onboarding-update-modal/onboarding-update-modal.component';
import { OnboardingRequestReviewModalComponent } from './onboarding-request-review-modal/onboarding-request-review-modal.component';
import { ReviewCommentBannerComponent } from './review-comment-banner/review-comment-banner.component';
import { OhW4Component } from './oh/oh-w4.component';
import { NcW4Component } from './nc/nc-w4.component';
import { NjW4Component } from './nj/nj-w4.component';
//import { SignaturePadDirective } from './signature/signaturepad.directive';
//import { SignaturePadComponent } from './signature/signature-pad.component';

export const OnboardingDocumentModule = angular
    .module("apex.mainApp.OnboardingDocument", [
        OnboardingDocumentRoutingModule,
        SharedModule,
        'pdfjsViewer',
        'ngTouch'
    ])
    .component("apexOnboardingDocumentW4Form", OnboardingDocumentW4FormComponent)
    .component("apexAddBankAccount", AddBankAccountComponent)
    .component("apexUserProfile", UserProfileComponent)
    .component("apexDirectDeposit", DirectDepositComponent)
    .component("apexConfirmationForm", ConfirmationFormComponent)
    .component("apexConfirmationEmployer", ConfirmationEmployerComponent)
    .component("apexFederalW4SignatureForm", FederalW4SignatureFormComponent)
    .component("apexFederalW4", FederalW4Component)
    .component("apexI9", I9Component)
    //.component("apexI9Signature", I9SignatureComponent)
    .component("apexNyW4", NyW4Component)
    .component("apexAlW4", AlW4Component)
    .component("apexArW4", ArW4Component)
    .component("apexAzW4", AZW4Component)
    .component("apexCoW4", CoW4Component)
    .component("apexKyW4", KyW4Component)
    .component("apexGaW4", GaW4Component)
    .component("apexMdW4", MdW4Component)
    .component("apexCaW4", CaW4Component)
    .component("apexCTW4", CtW4Component)
    .component("apexVaW4", VaW4Component)
    .component("apexIlW4", IlW4Component)
    .component("apexFormChoiceModal", FormChoiceModalComponent)
    .component("apexOnboardingUpdateModal", OnboardingUpdateModalComponent)
    .component("apexOnboardingRequestReviewModal", OnboardingRequestReviewModalComponent)
    .component("apexReviewCommentBanner", ReviewCommentBannerComponent)
    .component("apexOhW4", OhW4Component)
    .component("apexNcW4", NcW4Component)
    .component("apexNJW4", NjW4Component)
    .component("apexW9", W9Component)
    .component("apexStateBoilerPlate", StateBoilerPlateComponent)
    .component("apexBoilerPlateW4Modal", StateBoilerPlateComponent)
    .component("apexDocumentReset", ResetComponent)
    .component("apexDocumentEmpPortal", EmpPortalComponent)
    .component("apexDocumentEmpPortalList", EmpPortalItemsComponent)
    .component("apexOwnerModal", OwnerModalComponent)
    //.component("apexSignaturePad", SignaturePadComponent)
    .component("apexSignaturePadModal", SignaturePadComponent)
    .component("apexPreviewSignatureModal", PreviewSignatureModalComponent)
    .component("apexOwnerPreviewSignatureModal", OwnerPreviewSignatureModalComponent)
    .component("apexPreviewSignatureOwnerModal", PreviewSignatureOwnerModalComponent)
    .component("apexInfoModal", InfoModalComponent)
    .component("apexVoidCheckModal", VoidCheckModalComponent)
    .component("apexReviewModal", ReviewModalComponent)
    .component("apexUserProfileModal", UserProfileComponent)
    .component("apexFederalW4Modal", FederalW4Component)
    .component("apexW9Modal", W9Component)
    .component("apexALW4Modal", AlW4Component)
    .component("apexARW4Modal", ArW4Component)
    .component("apexAZW4Modal", AZW4Component)
    .component("apexKYW4Modal", KyW4Component)
    .component("apexGAW4Modal", GaW4Component)
    .component("apexMDW4Modal", MdW4Component)
    .component("apexNYW4Modal", NyW4Component)
    .component("apexCAW4Modal", CaW4Component)
    .component("apexCTW4Modal", CtW4Component)
    .component("apexVAW4Modal", VaW4Component)
    .component("apexILW4Modal", IlW4Component)
    .component("apexOHW4Modal", OhW4Component)
    .component("apexNCW4Modal", NcW4Component)
    .component("apexNJW4Modal", NjW4Component)
    .component("apexI9Modal", I9Component)
    .component("apexDDModal", DirectDepositComponent)
    .component("apexCommentsModal", OnboardingCommentsComponent)
    .component("apexOnboardingTerminationModal", TerminationModalComponent)
    .component("apexConfirmationModal", ConfirmationFormComponent)
    .component("apexOnboardingDashboardContainer", DashboardOnboardingContainerComponent)
    .component("apexOnboardingDashboard", DashboardOnboardingComponent)
    .component("apexOnboardingDashboardList", DashboardItemsOnboardingComponent)
    .run(dashboardOnboardingItemTemplate)
    .run(dashboardOnboardingListItemTemplate)
    .service("OnboardingDocumentService", OnboardingDocumentService)
    .service("employeeService", EmployeeService)
    .service("localeService", LocaleService)
    .service("onboardingDocumentViewService", OnboardingDocumentViewService)
    .service("onboardingActionPolicy", OnboardingActionPolicyService)
    .directive("apexSignature", SignaturePadDirective)
    .directive("pressReveal", PressRevealDirective)
    .directive("apexDateFormat", OnboardingDateDirective)
    .directive('validDate', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                ngModelCtrl.$validators.validDate = function (value) {
                    if (ngModelCtrl.$isEmpty(value)) {
                        // consider empty models to be valid
                        return true;
                    }

                    // Attempt to parse the date
                    //var parsedDate = new Date(viewValue);
                    return angular.isDate(value);
                };
            }
        };
    }).name;
